import * as React from 'react'
import Tooltip from './Tooltip'
import clsx from 'clsx'
import { FormTypes } from '@oneblink/types'
import useReplaceableText from '../../hooks/useReplaceableText'
import QuillHTML from '../QuillHTML'

function FormElementLabelContainer({
  className,
  element,
  id,
  required,
  children,
  leading,
  associateLabelWithInput = true
}: {
  className: string
  element: FormTypes.FormElementBase
  id: string
  required: boolean | undefined
  children: React.ReactNode
  leading?: React.ReactNode
  associateLabelWithInput?: boolean
}) {

  return (
    <div className={clsx('ob-form__element', className)}>
      <div className="label ob-label__container">
        {leading}
        <label
          className={clsx('ob-label', {
            'ob-label__required is-required': required,
          })}
          htmlFor={associateLabelWithInput ? id : undefined}
          id={`${id}-label`}
        >
          {element.label}
        </label>
        {element.hint &&
          (element.hintPosition === 'TOOLTIP' || !element.hintPosition) && (
            <HintTooltip hint={element.hint} inputId={id} />
          )}
      </div>
      {element.hint && element.hintPosition === 'BELOW_LABEL' && (
        <div className="ob-hint-text__container">
          <HintBelowLabel hint={element.hint} inputId={id} />
        </div>
      )}
      {children}
    </div>
  )
}

export function HintTooltip({
  hint,
  inputId,
}: {
  hint: string
  inputId: string
}) {
  const html = useReplaceableText(hint)

  return (
    <Tooltip
      title={<QuillHTML html={html} className="ob-hint-tooltip" />}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={10000}
      id={`${inputId}-hint`}
    >
      {/* Tooltip does not work with the MaterialIcon component - it must remain an i tag*/}
      <i
        className="material-icons has-text-grey ob-label__hint"
        role="tooltip"
        aria-label="More information"
      >
        info
      </i>
    </Tooltip>
  )
}

export function HintBelowLabel({
  hint,
  inputId,
}: {
  hint: string
  inputId: string
}) {
  const html = useReplaceableText(hint)

  return (
    <QuillHTML html={html} className="ob-hint-text" id={`${inputId}-hint`} />
  )
}

export default React.memo(FormElementLabelContainer)
